import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngxs/store';
import { GrdfState, SetCurrentAccessRightId } from '../grdf.state';

export const grdfAccessRightGuard: CanActivateFn = (
    next: ActivatedRouteSnapshot,
): boolean | UrlTree => {
    const router = inject(Router);
    const store = inject(Store);
    let id = next.params['accessRightId'];

    if (id) {
        const grdfAccessRights = store.selectSnapshot(GrdfState.grdfAccessRights);
        if (!grdfAccessRights?.find((ear) => ear.id === id)) {
            store.dispatch([new SetCurrentAccessRightId({ id })]);
        }
        store.dispatch([new SetCurrentAccessRightId({ id })]);
        return true;
    }

    return router.parseUrl('/main/grdf');
};
